import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { BusinessManagementService, SubscriptionPlanType, User } from '@eemo/api-client';
import { Subscription } from 'rxjs';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { NgTemplateOutlet, NgIf } from '@angular/common';
import { ModalBaseComponent } from '../base/modal-base/modal-base.component';

export class SubscriptionChoiceDialogData {
  user: User;
}

@Component({
    selector: 'app-subscription-choice-dialog',
    templateUrl: './subscription-choice-dialog.component.html',
    styleUrls: ['./subscription-choice-dialog.component.scss'],
    standalone: true,
    imports: [ModalBaseComponent, NgTemplateOutlet, MatDialogModule, MatButtonModule, NgIf, MatIconModule, MatProgressSpinnerModule]
})
export class SubscriptionChoiceDialogComponent implements OnInit, OnDestroy {
  readonly textTitleMonthly = 'Mensuel';
  readonly textDurationMonthly = '1 mois';
  readonly priceMonthly = '9,99';
  readonly textPriceMonthly = 'mois';

  readonly textTitleYearly = 'Annuel';
  readonly textDurationYearly = '1 an';
  readonly priceYearly = '99';
  readonly textPriceYearly = 'an';

  loading = false;
  dialogTitle: string;
  planType = SubscriptionPlanType.MONTHLY;
  textTitle = this.textTitleMonthly;
  textDuration = this.textDurationMonthly;
  price = this.priceMonthly;
  priceText = this.textPriceMonthly;
  isPlanYearly = false;

  buttonMonthlyCss = 'selected';
  buttonYearlyCss = '';

  sub = new Subscription();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: SubscriptionChoiceDialogData,
    public dialogRef: MatDialogRef<SubscriptionChoiceDialogComponent>,
    private businessService: BusinessManagementService
  ) {
    this.dialogTitle = 'Choisissez votre abonnement';
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  changePlanToMonthly(): void {
    this.changePlan(SubscriptionPlanType.MONTHLY);
  }

  changePlanToYearly(): void {
    this.changePlan(SubscriptionPlanType.YEARLY);
  }

  changePlan(planType: SubscriptionPlanType): void {
    this.planType = planType;
    if (planType === SubscriptionPlanType.YEARLY) {
      this.textTitle = this.textTitleYearly;
      this.textDuration = this.textDurationYearly;
      this.price = this.priceYearly;
      this.priceText = this.textPriceYearly;
      this.buttonYearlyCss = 'selected';
      this.buttonMonthlyCss = '';
      this.isPlanYearly = true;
    } else {
      this.textTitle = this.textTitleMonthly;
      this.textDuration = this.textDurationMonthly;
      this.price = this.priceMonthly;
      this.priceText = this.textPriceMonthly;
      this.buttonYearlyCss = '';
      this.buttonMonthlyCss = 'selected';
      this.isPlanYearly = false;
    }
  }

  subscribeUser(): void {
    this.loading = true;
    this.sub = this.businessService.addUserSubscription(this.data.user.uid, this.planType).subscribe({
      next: (p) => {
        window.location.href = p.paymentCheckoutUrl;
      },
      error: () => {
        this.loading = false;
      }
    });
  }
}
